import AccountSettingActivity from '@activities/account/AccountSettingActivity';
import AccountTerminationActivity from '@activities/account/AccountTerminationActivity';
import LogoutModal from '@activities/account/LogoutModal';
import NickNameChangeModal from '@activities/account/NickNameChangeModal';
import AlertActivity from '@activities/AlertActivity';
import AppTerminationModal from '@activities/AppTerminationModal';
import IdentifyFailActivity from '@activities/auth/IdentifyFailActivity';
import IdentifySuccessActivity from '@activities/auth/IdentifySuccessActivity';
import SignInActivity from '@activities/auth/SignInActivity';
import SignInWithAppleActivity from '@activities/auth/SignInWithAppleActivity';
import SignInWithGoogleActivity from '@activities/auth/SignInWithGoogleActivity';
import SignInWithKakaoActivity from '@activities/auth/SignInWithKakaoActivity';
import SignInWithPhoneActivity from '@activities/auth/SignInWithPhoneActivity';
import SignUpActivity from '@activities/auth/SignUpActivity';
import CartActivity from '@activities/cart/CartActivity';
import CloseInquiryModal from '@activities/customerService/CloseInquiryModal';
import CustomerServiceActivity from '@activities/customerService/CustomerServiceActivity';
import InquiryActivity from '@activities/customerService/InquiryActivity';
import InquiryCommentBottomSheet from '@activities/customerService/InquiryCommentBottomSheet';
import InquiryCommentModal from '@activities/customerService/InquiryCommentModal';
import InquiryLogActivity from '@activities/customerService/InquiryLogActivity';
import InquiryTypeBottomSheet from '@activities/customerService/InquiryTypeBottomSheet';
import DeepLinkActivity from '@activities/deepLink/DeepLinkActivity';
import EasyCardActivity from '@activities/easyCard/EasyCardActivity';
import EasyCardDeleteModal from '@activities/easyCard/EasyCardDeleteModal';
import EasyCardManageBottomSheet from '@activities/easyCard/EasyCardManageBottomSheet';
import EasyCardNameBottomSheet from '@activities/easyCard/EasyCardNameBottomSheet';
import EasyCardPinActivity from '@activities/easyCard/EasyCardPinActivity';
import EasyCardPinLockedModal from '@activities/easyCard/EasyCardPinLockedModal';
import EasyCarRegistrationActivity from '@activities/easyCard/EasyCarRegistrationActivity';
import EasyCardIdentifyFailActivity from '@activities/easyCard/identify/EasyCardIdentifyFailActivity';
import EasyCardIdentifySuccessActivity from '@activities/easyCard/identify/EasyCardIdentifySuccessActivity';
import PaymentFailedActivity from '@activities/errors/PaymentFailedActivity';
import UserPaymentCancelActivity from '@activities/errors/UserPaymentCancelActivity';
import ForceUpdateModal from '@activities/ForceUpdateModal';
import GiftAddContactActivity from '@activities/gift/GiftAddContactActivity';
import GiftCanceledModal from '@activities/gift/GiftCanceledModal';
import GiftCancelModal from '@activities/gift/GiftCancelModal';
import GiftItemActivity from '@activities/gift/GiftItemActivity';
import GiftMenuDetailActivity from '@activities/gift/GiftMenuDetailActivity';
import GiftOrderActivity from '@activities/gift/GiftOrderActivity';
import ContactMethodBottomSheet from '@activities/gift/GiftOrderActivity/components/Receiver/ContactMethodBottomSheet';
import GiftOrderCompleteActivity from '@activities/gift/GiftOrderCompleteActivity';
import GiftReceivedActivity from '@activities/gift/GiftReceivedActivity';
import DeleteGiftModal from '@activities/gift/GiftReceivedActivity/components/DeleteGiftModal';
import GiftsActivity from '@activities/gift/GiftsActivity';
import GiftSentActivity from '@activities/gift/GiftSentActivity';
import CancelPaymentModal from '@activities/gift/GiftSentActivity/components/CancelPaymentModal';
import GiftUsageActivity from '@activities/gift/GiftUsageActivity';
import RegisterGiftActivity from '@activities/gift/RegisterGiftActivity';
import GpsPermissionModal from '@activities/GpsPermissionModal';
import ItemActivity from '@activities/items/ItemActivity';
import ItemFilterBottomSheet from '@activities/items/ItemFilterBottomSheet';
import ItemNutritionModal from '@activities/items/ItemNutritionModal';
import ItemsActivity from '@activities/items/ItemsActivity';
import SinglePurchaseModal from '@activities/items/ItemsActivity/fragments/MyMenuFragment/components/SinglePurchaseModal';
import PersonalOptionActivity from '@activities/items/PersonalOptionActivity';
import LinkActivity from '@activities/LinkActivity';
import MainActivity from '@activities/MainActivity';
import ExternalShopModal from '@activities/MainActivity/components/QuickOrder/ExternalShopModal';
import ItemSoldOutModal from '@activities/MainActivity/ItemSoldOutModal';
import NotOperationModal from '@activities/MainActivity/NotOperationModal';
import CouponActivity from '@activities/membership/coupon/CouponActivity';
import CouponDetailActivity from '@activities/membership/coupon/CouponDetailActivity';
import CouponSortBottomSheet from '@activities/membership/coupon/CouponSortBottomSheet';
import PointActivity from '@activities/membership/point/PointActivity';
import AttendanceCheckActivity from '@activities/membership/stamp/AttendanceCheckActivity';
import StampsActivity from '@activities/membership/stamp/StampsActivity';
import StampScopeBottomSheet from '@activities/membership/stamp/StampScopeBottomSheet';
import StampSortBottomSheet from '@activities/membership/stamp/StampSortBottomSheet';
import MyMenuActivity from '@activities/myMenu/MyMenuActivity';
import MyMenuSettingBottomSheet from '@activities/myMenu/MyMenuSettingBottomSheet';
import DeleteAllMyMenuModal from '@activities/myMenu/MyMenuSettingBottomSheet/DeleteAllMyMenuModal';
import BoardActivity from '@activities/news/BoardActivity';
import EventActivity from '@activities/news/EventActivity';
import NoticeActivity from '@activities/news/NoticeActivity';
import NotificationActivity from '@activities/NotificationActivity';
import NotReadyModal from '@activities/NotReadyModal';
import CancelOrderModal from '@activities/order/CancelOrderModal';
import FingerPayActivity from '@activities/order/FingerPayActivity';
import ItemCouponTargetBottomSheet from '@activities/order/ItemCouponTargetBottomSheet';
import OrderActivity from '@activities/order/OrderActivity';
import OrderCompleteActivity from '@activities/order/OrderCompleteActivity';
import OrderCouponActivity from '@activities/order/OrderCouponActivity';
import OrderEasyCardBottomSheet from '@activities/order/OrderEasyCardBottomSheet';
import OrderEasyCardPinActivity from '@activities/order/OrderEasyCardPinActivity';
import OrderGiftBottomSheet from '@activities/order/OrderGiftBottomSheet';
import OrderLogActivity from '@activities/order/OrderLogActivity';
import OrderLogsActivity from '@activities/order/OrderLogsActivity';
import OrderPaymentMethodBottomSheet from '@activities/order/OrderPaymentMethodBottomSheet';
import OrderPrepaidCardBottomSheet from '@activities/order/OrderPrepaidCardBottomSheet';
import OrderReceiptActivity from '@activities/order/OrderReceiptActivity';
import TossOrderFailActivity from '@activities/order/toss/TossOrderFailActivity';
import TossOrderSuccessActivity from '@activities/order/toss/TossOrderSuccessActivity';
import PermissionBottomSheet from '@activities/PermissionBottomSheet';
import CardManageBottomSheet from '@activities/prepaidCard/CardManageBottomSheet';
import MyPrepaidCardActivity from '@activities/prepaidCard/MyPrepaidCardActivity';
import DeleteCardModal from '@activities/prepaidCard/MyPrepaidCardActivity/components/DeleteCardModal';
import PrepaidCardBarcodeBottomSheet from '@activities/prepaidCard/PrepaidCardBarcodeBottomSheet';
import PrepaidCardChargeActivity from '@activities/prepaidCard/PrepaidCardChargeActivity';
import PrepaidCardChargeCompleteActivity from '@activities/prepaidCard/PrepaidCardChargeCompleteActivity';
import PrepaidCardGiftDetailActivity from '@activities/prepaidCard/PrepaidCardGiftDetailActivity';
import PrepaidCardImageActivity from '@activities/prepaidCard/PrepaidCardImageActivity';
import PrepaidCardImagesActivity from '@activities/prepaidCard/PrepaidCardImagesActivity';
import PrepaidCardLogActivity from '@activities/prepaidCard/PrepaidCardLogActivity';
import CancelChargeModal from '@activities/prepaidCard/PrepaidCardLogActivity/components/CancelChargeModal';
import PrepaidCardOrderCompleteActivity from '@activities/prepaidCard/PrepaidCardOrderCompleteActivity';
import PrepaidCardTransferActivity from '@activities/prepaidCard/PrepaidCardTransferActivity';
import TransferConfirmModal
    from '@activities/prepaidCard/PrepaidCardTransferActivity/components/TransferConfirmModal';
import UpdateCardNameBottomSheet from '@activities/prepaidCard/UpdateCardNameBottomSheet';
import ProjectActivity from '@activities/ProjectActivity';
import ShopDetailBottomSheet from '@activities/shops/ShopDetailBottomSheet';
import ShopListActivity from '@activities/shops/ShopListActivity';
import ShopLocationBottomSheet from '@activities/shops/ShopLocationBottomSheet';
import ShopPrepareModal from '@activities/shops/ShopPrepareModal';
import TermDetailActivity from '@activities/terms/TermDetailActivity';
import TermSelectBottomSheet from '@activities/terms/TermSelectBottomSheet';
import TestActivity from '@activities/test/TestActivity';
import TierBenefitsBottomSheet from '@activities/tier/TierBenefitsBottomSheet';
import TierCalculatedDateBottomSheet from '@activities/tier/TierCalculatedDateBottomSheet';
import TierHistoryActivity from '@activities/tier/TierHistoryActivity';
import WithdrawManualActivity from '@activities/WithdrawManualActivity';
import BarcodeModal from '@modals/BarcodeModal';
import { basicUIPlugin } from '@stackflow/plugin-basic-ui';
import { historySyncPlugin } from '@stackflow/plugin-history-sync';
import { basicRendererPlugin } from '@stackflow/plugin-renderer-basic';
import { stackflow } from '@stackflow/react';

import { config } from './stackflow.config';

const historySync = historySyncPlugin({
    config,
    fallbackActivity: () => 'MainActivity',
});

/**
 * `<Link />` from `@stackflow/link` resolves its `href` through this.
 * Provide it via `<LinkUrlResolverProvider />` above every `<Link />`.
 */
export const linkUrlResolver = historySync.urlResolver;

export const { Stack, actions } = stackflow({
    config,
    components: {
        MainActivity,
        NotOperationModal,
        ItemSoldOutModal,
        NotificationActivity,
        SignInActivity,
        SignInWithPhoneActivity,
        SignInWithKakaoActivity,
        SignInWithAppleActivity,
        SignInWithGoogleActivity,
        SignUpActivity,
        IdentifySuccessActivity,
        IdentifyFailActivity,
        TermDetailActivity,
        TermSelectBottomSheet,
        BoardActivity,
        EventActivity,
        NoticeActivity,
        ShopListActivity,
        ShopLocationBottomSheet,
        ShopDetailBottomSheet,
        ShopPrepareModal,
        ItemsActivity,
        ItemFilterBottomSheet,
        ItemActivity,
        ItemNutritionModal,
        PersonalOptionActivity,
        OrderActivity,
        OrderCouponActivity,
        ItemCouponTargetBottomSheet,
        OrderGiftBottomSheet,
        OrderPrepaidCardBottomSheet,
        OrderPaymentMethodBottomSheet,
        OrderEasyCardBottomSheet,
        OrderEasyCardPinActivity,
        FingerPayActivity,
        CustomerServiceActivity,
        InquiryActivity,
        InquiryLogActivity,
        CloseInquiryModal,
        InquiryCommentModal,
        InquiryCommentBottomSheet,
        InquiryTypeBottomSheet,
        ProjectActivity,
        OrderLogsActivity,
        OrderLogActivity,
        OrderReceiptActivity,
        OrderCompleteActivity,
        CancelOrderModal,
        AccountSettingActivity,
        AccountTerminationActivity,
        NickNameChangeModal,
        LogoutModal,
        GiftsActivity,
        GiftItemActivity,
        GiftMenuDetailActivity,
        GiftSentActivity,
        GiftReceivedActivity,
        GiftUsageActivity,
        GiftOrderActivity,
        GiftAddContactActivity,
        GiftOrderCompleteActivity,
        GiftCancelModal,
        GiftCanceledModal,
        RegisterGiftActivity,
        DeleteGiftModal,
        CancelPaymentModal,
        ContactMethodBottomSheet,
        MyPrepaidCardActivity,
        PrepaidCardImagesActivity,
        PrepaidCardImageActivity,
        CardManageBottomSheet,
        UpdateCardNameBottomSheet,
        PrepaidCardBarcodeBottomSheet,
        PrepaidCardChargeActivity,
        PrepaidCardTransferActivity,
        PrepaidCardOrderCompleteActivity,
        PrepaidCardLogActivity,
        PrepaidCardGiftDetailActivity,
        DeleteCardModal,
        TransferConfirmModal,
        CancelChargeModal,
        PrepaidCardChargeCompleteActivity,
        MyMenuActivity,
        MyMenuSettingBottomSheet,
        PointActivity,
        StampsActivity,
        StampScopeBottomSheet,
        StampSortBottomSheet,
        CartActivity,
        BarcodeModal,
        CouponActivity,
        CouponSortBottomSheet,
        CouponDetailActivity,
        ExternalShopModal,
        UserPaymentCancelActivity,
        PaymentFailedActivity,
        AlertActivity,
        GpsPermissionModal,
        DeleteAllMyMenuModal,
        SinglePurchaseModal,
        PermissionBottomSheet,
        LinkActivity,
        TestActivity,
        AppTerminationModal,
        ForceUpdateModal,
        AttendanceCheckActivity,
        EasyCardActivity,
        EasyCardPinActivity,
        EasyCardPinLockedModal,
        EasyCardManageBottomSheet,
        EasyCardNameBottomSheet,
        EasyCardDeleteModal,
        EasyCarRegistrationActivity,
        EasyCardIdentifyFailActivity,
        EasyCardIdentifySuccessActivity,
        WithdrawManualActivity,
        TossOrderSuccessActivity,
        TossOrderFailActivity,
        TierBenefitsBottomSheet,
        TierHistoryActivity,
        TierCalculatedDateBottomSheet,
        NotReadyModal,
        DeepLinkActivity,
    },
    plugins: [
        basicRendererPlugin(),
        basicUIPlugin({
            theme: 'cupertino',
        }),
        historySync,
    ],
});
